var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box box-content" }, [
      _c(
        "div",
        { staticClass: "box-left fl" },
        [
          _c(
            "el-carousel",
            { attrs: { trigger: "click", height: "367px", autoplay: true } },
            _vm._l(_vm.carouselList, function(item, index) {
              return _c("el-carousel-item", { key: index }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "relative",
                      height: "100%",
                      overflow: "hidden"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "title",
                        staticStyle: { position: "absolute", bottom: "0" }
                      },
                      [_vm._v(_vm._s(item.title))]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      class: { issusor: item.newId ? true : false },
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        src: _vm.publicPath + item.homePageImage,
                        alt: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.handelDeatil(item)
                        }
                      }
                    })
                  ]
                )
              ])
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "box-right fr" }, [
        _c("div", { staticClass: "box-title" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fr m-more",
              on: {
                click: function($event) {
                  return _vm.handelClick("notice")
                }
              }
            },
            [_vm._v("更多>")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "clear" }),
        _vm._v(" "),
        _c("div", { staticClass: "box-info" }, [
          _c(
            "ul",
            _vm._l(_vm.newsList, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "m-item",
                  on: {
                    click: function($event) {
                      return _vm.turnDetail("new", item)
                    }
                  }
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "fl m-main",
                        attrs: { title: item.title }
                      },
                      [
                        _c("div", { staticClass: "flag" }),
                        _vm._v(
                          "\n                " +
                            _vm._s(item.title) +
                            "\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "fr m-time" }, [
                      _vm._v(_vm._s(_vm._f("dateFormat")(item.publishTime)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clear" })
                ]
              )
            }),
            0
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "clear" }),
    _vm._v(" "),
    _c("div", { staticClass: "box box-middle" }, [
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("div", {
        staticStyle: {
          float: "left",
          width: "1px",
          height: "100%",
          "background-color": "white"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "box-info",
          staticStyle: { padding: "0 10px", float: "left", width: "1000px" }
        },
        [
          _c(
            "ul",
            {
              staticStyle: { height: "100%", color: "white", padding: "8px 0" }
            },
            _vm._l(_vm.noticeList.slice(0, 3), function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "m-item",
                  staticStyle: { "border-bottom": "none" },
                  on: {
                    click: function($event) {
                      return _vm.turnDetail("notice", item)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "middle-label" }, [
                    _c(
                      "div",
                      {
                        staticClass: "fl m-main",
                        attrs: { title: item.title }
                      },
                      [_vm._v(_vm._s(item.title))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "fr m-time" }, [
                      _vm._v(_vm._s(_vm._f("dateFormat")(item.publishTime)))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clear" })
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clear" })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "clear" }),
    _vm._v(" "),
    _c("div", { staticClass: "box box-wrapper" }, [
      _c("div", { staticClass: "box-item fl" }, [
        _c("div", { staticClass: "box-title" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fr m-more",
              on: {
                click: function($event) {
                  return _vm.handelClick("monitoring")
                }
              }
            },
            [_vm._v("更多>")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "clear" }),
        _vm._v(" "),
        _c("div", { staticClass: "box-main" }, [
          _c(
            "ul",
            [
              _vm._l(_vm.monitoringList, function(supervision, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "li-item",
                    on: {
                      click: function($event) {
                        return _vm.turnDetail("monitoring", supervision)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fl m-main",
                        attrs: { title: supervision.title }
                      },
                      [
                        _c("div", { staticClass: "flag" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(supervision.title) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "fr m-time" }, [
                      _vm._v(
                        _vm._s(_vm._f("dateFormat")(supervision.publishTime))
                      )
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c("li", { staticClass: "clear" })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box-item fl" }, [
        _c("div", { staticClass: "box-title" }, [
          _vm._m(4),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fr m-more",
              on: {
                click: function($event) {
                  return _vm.handelClick("comprehensiveControl")
                }
              }
            },
            [_vm._v("更多>")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "clear" }),
        _vm._v(" "),
        _c("div", { staticClass: "box-main" }, [
          _c(
            "ul",
            [
              _vm._l(_vm.comprehensiveList, function(comprehensive, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "li-item",
                    on: {
                      click: function($event) {
                        return _vm.turnDetail(
                          "comprehensiveControl",
                          comprehensive
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fl m-main",
                        attrs: { title: comprehensive.title }
                      },
                      [
                        _c("div", { staticClass: "flag" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(comprehensive.title) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "fr m-time" }, [
                      _vm._v(
                        _vm._s(_vm._f("dateFormat")(comprehensive.publishTime))
                      )
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c("li", { staticClass: "clear" })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box-item fl" }, [
        _c("div", { staticClass: "box-title" }, [
          _vm._m(5),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fr m-more",
              on: {
                click: function($event) {
                  return _vm.handelClick("policiesAndRegulations")
                }
              }
            },
            [_vm._v("更多>")]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "clear" }),
        _vm._v(" "),
        _c("div", { staticClass: "box-main" }, [
          _c(
            "ul",
            [
              _vm._l(_vm.regulationsList, function(regulations, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "li-item",
                    on: {
                      click: function($event) {
                        return _vm.turnDetail(
                          "policiesAndRegulations",
                          regulations
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "fl m-main",
                        attrs: { title: regulations.title }
                      },
                      [
                        _c("div", { staticClass: "flag" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(regulations.title) +
                            "\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "fr m-time" }, [
                      _vm._v(
                        _vm._s(_vm._f("dateFormat")(regulations.createTime))
                      )
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c("li", { staticClass: "clear" })
            ],
            2
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "clear" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fl" }, [
      _c("img", {
        staticStyle: { "vertical-align": "middle" },
        attrs: {
          src: require("../assets/images/news.png"),
          width: "32",
          height: "25"
        }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "m-title",
          staticStyle: {
            color: "#00ACD8",
            "font-size": "17px",
            "font-weight": "400",
            "padding-left": "10px"
          }
        },
        [_vm._v("水保新闻")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "inline-block",
          width: "70px",
          height: "100%",
          position: "relative",
          float: "left"
        }
      },
      [
        _c("img", {
          staticStyle: {
            position: "absolute",
            top: "50%",
            "margin-top": "-20px",
            left: "50%",
            "margin-left": "-20px"
          },
          attrs: {
            src: require("../assets/images/broadcast.png"),
            width: "40",
            height: "40"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "middle-title",
        staticStyle: {
          display: "inline-block",
          width: "70px",
          height: "120px",
          "line-height": "120px",
          float: "left",
          "font-size": "25px",
          color: "white",
          "font-weight": "bolder"
        }
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              display: "inline-block",
              "vertical-align": "middle",
              "line-height": "35px",
              "letter-spacing": "10px"
            }
          },
          [_vm._v("\n        通知\n        "), _c("br"), _vm._v("公告\n      ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-title-l fl" }, [
      _c("span", { staticClass: "col-2" }),
      _vm._v(" "),
      _c("span", { staticClass: "col-1" }),
      _vm._v(" "),
      _c("span", { staticClass: "m-title" }, [_vm._v("监督监测")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-title-l fl" }, [
      _c("span", { staticClass: "col-2" }),
      _vm._v(" "),
      _c("span", { staticClass: "col-1" }),
      _vm._v(" "),
      _c("span", { staticClass: "m-title" }, [_vm._v("综合治理")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-title-l fl" }, [
      _c("span", { staticClass: "col-2" }),
      _vm._v(" "),
      _c("span", { staticClass: "col-1" }),
      _vm._v(" "),
      _c("span", { staticClass: "m-title" }, [_vm._v("政策法规")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23543608", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23543608","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = null
// module chunks = 